import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const get_audio_assessment_question = createAsyncThunk(
  "audioassessment/get",
  async ({ usertype, program, clas, subject }) => {
    let response = await api.get(
      "getMasterStudentAudioAssessmentQuestions/" +
        usertype +
        "/" +
        program +
        "/" +
        clas +
        "/" +
        subject
    );
    return response.data;
  }
);

export const save_audio_assessment_question = createAsyncThunk(
  "audioassessment/save",
  async (body) => {
    console.log(body, "save with body");
    let response = await api.post(
      "saveMasterStudentAudioAssessmentQuestion",
      body
    );
    return response.data;
  }
);
export const update_audio_assessment_question = createAsyncThunk(
  "audioassessment/update",
  async (body) => {
    try {
      let response = await api.put(
        "updateMasterStudentAudioAssessmentQuestion",
        body
      );
      return response.data;
    } catch (err) {
      console.log(err, "err");
    }
  }
);

export const delete_audio_assessment_question = createAsyncThunk(
  "audioassessment/delete",
  async (id) => {
    let response = await api.delete(
      "deleteMasterStudentAudioAssessmentQuestion/" + id
    );
    return response.data;
  }
);
